module.exports = __webpack_public_path__ + "static/img/star.cb829ed3.svg";